import React from "react";
import { MODULE_TIERS } from "@/lib/moduleTiers";

/**
 * Small premium tier badge used in the sidebar and on placeholder pages.
 *
 * Props:
 *   tier:  "beta" | "pro" | "enterprise"
 *   size:  "xs" (sidebar) | "sm" (page header)  default "xs"
 *
 * Palette: only navy / teal — no aggressive colors.
 */
export default function ModuleBadge({ tier, size = "xs", className = "" }) {
  const def = MODULE_TIERS[tier];
  if (!def) return null;

  const isSmall = size === "xs";
  const base = isSmall
    ? "px-1.5 py-[1px] text-[9px] font-bold tracking-[0.14em]"
    : "px-2.5 py-1 text-[11px] font-bold tracking-[0.14em]";

  const tones = {
    teal: "bg-[#F0FDFA] text-[#0F766E] border border-[#0F766E]/30",
    navy:
      "bg-[#E2E8F0]/60 text-[#102A43] border border-[#102A43]/20",
    navy_solid: "bg-[#102A43] text-white border border-[#102A43]",
  };

  return (
    <span
      data-testid={`module-badge-${tier}`}
      className={`inline-flex items-center rounded uppercase select-none ${base} ${tones[def.tone] || tones.navy} ${className}`}
    >
      {def.label}
    </span>
  );
}
